module.exports = __webpack_public_path__ + "static/media/budget_logo.2aa592b5.svg";